var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAppIcon = function SvgAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 10,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.117 31.029-1.354 5.885h-2.97l3.048-13.184h2.97l-1.168 5.026h5.608l1.169-5.026h2.98l-3.05 13.183h-2.978l1.353-5.885h-5.608v.001ZM27.05 36.913l-.146-11.063c-.051.25-.128.607-.228 1.069-.101.461-.183.821-.248 1.077l-2.055 8.917h-2.795l3.047-13.182h4.363l.204 10.365 4.996-10.365h4.314l-3.048 13.182H32.66l2.055-8.917.267-1.077c.113-.462.197-.82.248-1.07l-5.267 11.064H27.05ZM41.645 32.504l-1.013 4.41h-2.95L40.73 23.73h2.95l-1.255 5.429 6.796-5.428h3.876l-7.138 5.428 4.392 7.754h-3.856l-3.106-5.76-1.744 1.35v.001Z",
    fill: "#FFA0CC"
  })));
};

export default SvgAppIcon;